import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';
import ListingCard from '../../../shared/ListingCard/listing.card.vue';
import * as T_T from 'cryface';
import { IListingCardParams } from 'src/shared/ListingCard/listing.card.params';
import ContactAgent from '../../../shared/ContactAgent/contact.agent.vue';
import AboutMe from '../../../shared/AboutMe/about.me.vue';
import { WechatDelegate } from '../../../services/DataDelegate/WechatDelegate/wechat.delegate';
import { HimuraInject } from 'himura';
import { Models } from 'src/models/models';
import * as dd from 'dingtalk-jsapi';

@Component({
    components: {
        ListingCard,
        ContactAgent,
        AboutMe
    }
})
export default class HybridShareListPage extends Vue {
    public dataM: any = null;
    public configs: any;
    public showSignature: any = true;
    public userName: any = '';
    public realEstateBoard: any;
    public wechat = new WechatDelegate();
    @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
    public async onUserChanged(val: any, oldVal: any) {
        if (T_T.simpleDetect(val.value)) {
            this.userName = val.value.agentName;
            await this.configWX(val);
            await this.configDingTalk(val);
        }
    }

    public async configDingTalk(val: any) {
        if (window.navigator.userAgent.toLowerCase().indexOf('dingtalk') === -1) {
            return;
        }
        dd.biz.navigation.setRight({
            show: true,
            control: true,
            text: '',
            onSuccess: function () {
                dd.biz.util.share({
                    type: 0,
                    url: location.href.split('#')[0],
                    title: `特色房源`,
                    content: `来自经纪${val.value.agentName}的房源`,
                    image: 'https://files.realjaja.com/rifo_wechat_logo.png'
                });
            }
        });
    }
    public async created() {
        const queryIds = this.$route.query['ids'];
        if (queryIds.includes('_')) {
            this.realEstateBoard = (queryIds as string).split('_')[0].split('-')[0];
        } else if (queryIds.includes('%40')) {
            this.realEstateBoard = (queryIds as string).split('%40')[0].split('-')[0];
        } else {
            this.realEstateBoard = (queryIds as string).split('@')[0].split('-')[0];
        }
        this.configs = new CommonConfig();
    }

    public async mounted() {
        let ids;
        if (this.$route.query['ids'].includes('_')) {
            ids = (this.$route.query['ids'] as string).split('_').join('@');
        } else if (this.$route.query['ids'].includes('%40')) {
            ids = (this.$route.query['ids'] as string).split('%40').join('@');
        } else {
            ids = this.$route.query['ids'];
        }

        this.showSignature = T_T.simpleDetect(this.$route.query['signature']) ? this.$route.query['signature'] : false;
        if (T_T.simpleDetect(ids)) {
            const apiHost = this.configs.cmisapiHost;
            try {
                const fetched = await AxiosPromise.get(`${apiHost}/ac/shareList?text=${ids}&ltype=0`);
                if (fetched.code === 200) {
                    this.dataM = fetched.data.map((v: any) => this.dataMapper(v));
                } else {
                    console.error(fetched.msg);
                }
            } catch (e) {
                console.error(e);
            }
        } else {
            console.error('Invalid Url Query, Wrong Ids');
        }
    }

    public async configWX(val: any) {
        if (T_T.simpleDetect(val.value)) {
            if (this.wechat.isWeChat()) {
                const entry = HimuraInject.Injector.getInstance().getResourceByKey('entryUrl')!.value;
                const link = this.wechat.isWechatIos() ? entry.split('#')[0] : location.href.split('#')[0];
                const shareConfig: Models.IWechatShareConfig = {
                    title: `特色房源`,
                    desc: `来自经纪${val.value.agentName}的房源`,
                    link: location.href.split('#')[0],
                    imgUrl: 'https://files.realjaja.com/rifo_wechat_logo.png',
                    success: () => {
                    }
                };
                const wx = require('weixin-js-sdk');
                const options = await this.wechat.getConfig(link);
                wx.config(options);
                try {
                    await this.wechat.ReadyPromise(wx);
                    this.wechat.share(wx, shareConfig);
                } catch (e) {
                    alert(e.errMsg);
                    alert(location.href);
                }
            }
        }
    }

    public signature() {
        return !this.$store.state.app.isWWW && (this.showSignature === 'true');
    }

    public dataMapper(data: any) {
        const dataModel: IListingCardParams = {
            id: '',
            price: -1,
            type: '',
            address: '',
            bedrooms: '',
            bedroomPlus: '',
            bathrooms: '',
            garages: '',
            picture: '',
            mlsNumber: '',
        };
        try {
            dataModel.id = data.identifier;
            dataModel.price = T_T.simpleDetect(Number(data.price)) ? Number(data.price) : -1;
            dataModel.type = T_T.simpleDetect(data.listingType) ? data.listingType : '';
            dataModel.address = T_T.simpleDetect(data.fullAddress) ? data.fullAddress : '';
            dataModel.bedrooms = T_T.simpleDetect(data.bedrooms) ? data.bedrooms : -1;
            dataModel.bedroomPlus = T_T.simpleDetect(data.bedroomsPlus) ? data.bedroomsPlus : -1;
            dataModel.garages = -1;
            dataModel.bathrooms = T_T.simpleDetect(data.washrooms) ? data.washrooms : -1;
            dataModel.picture = T_T.simpleDetect(data.newPictures) ? data.newPictures : '';
            dataModel.mlsNumber = T_T.simpleDetect(data.mlsNumber) ? data.mlsNumber : '';
        } catch (e) {
            console.error(e);
        }
        return dataModel;
    }
}
